import { render, staticRenderFns } from "./open_mr_badge.vue?vue&type=template&id=66c43600"
import script from "./open_mr_badge.vue?vue&type=script&lang=js"
export * from "./open_mr_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports